import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import logo from "../../images/logo.gif";
import { Link, useHistory } from "react-router-dom";
const Menu = () => {
    let history = useHistory();
    return (
        <Navbar collapseOnSelect expand="lg">
            <Container >
                <Navbar.Brand href="#home">
                    <Link to="/"><img src={logo} alt="logo" id="siteLogo" /></Link>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" ><i className="fa fa-bars"></i> </Navbar.Toggle>
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link className="textColor navLink" onClick={() => history.push("/")} >Home</Nav.Link>
                        <Nav.Link className="textColor navLink" onClick={() => history.push("/about")}>About</Nav.Link>
                        <Nav.Link className="textColor navLink" onClick={() => history.push("/works")}>Works</Nav.Link>
                        <Nav.Link className="textColor navLink" onClick={() => history.push("/blogs")}>Blogs</Nav.Link>
                        <Nav.Link className="textColor navLink" onClick={() => history.push("/contact")}>Contact</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Menu;